module.exports = __webpack_public_path__ + "static/banner-phones-2a7fb4f4daae540828be6d8c27404a54.svg";